import { Dispatch } from "redux";
import { RefreshPlayerActionTypes, RefreshPlayerCreateAction } from "../../types/auth/refreshPlayerData";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const refreshPlayerData = (data: { refresh_token: string }) => {
    return async (dispatch: Dispatch<RefreshPlayerCreateAction>) => {
        try {
            dispatch({ type: RefreshPlayerActionTypes.GET_REFRESH_PLAYER_DATA });

            const response = await axios({
                method: 'post',
                url: `/api/refresh`,
                data: {
                    refresh_token: data.refresh_token,
                },
                withCredentials: false,
            });

            dispatch({
                type: RefreshPlayerActionTypes.GET_REFRESH_PLAYER_DATA_SUCCESS,
                payload: response.data ?? response.status,
            });

        } catch (error: any) {
            let errorPayload: ErrorResponse;

            if (error.response?.data) {
                errorPayload = typeof error.response.data === 'string'
                    ? { code: error.response.status, message: error.response.data }
                    : { code: error.response.data.code, message: error.response.data.message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }

            dispatch({ type: RefreshPlayerActionTypes.GET_REFRESH_PLAYER_DATA_ERROR, payload: errorPayload });
        }
    };
};